var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.activeClass,attrs:{"role":"presentation"}},[_c('a',{attrs:{"href":_vm.href,"aria-controls":_vm.ariaControls,"role":"tab","data-toggle":"tab"},on:{"click":function($event){return _vm.$emit('click', _vm.title)}}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231bf897","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Tabs/NavTab.vue
// module id = null
// module chunks = 